import { getAnalyticsItemType } from '@mb/lib';
import { getAnalyticsItemCategoriesByTaxonomy } from './getAnalyticsItemCategoriesByTaxonomy';
import { pushLearnMoreCtaClickDataLayer } from './pushLearnMoreCtaClickDataLayer';
import { pushLearnMoreInteraction } from './pushLearnMoreInteraction';
import { ProductSearchMaterial } from '../../types/material';

export const handleMiniPdpDetailsClickDataLayer = (
  product: ProductSearchMaterial,
  isLearnMoreNewTab = false,
) => {
  window.splitFactory?.client()?.track('user', 'mb_qv_learn_more', undefined, {
    learnMoreLocation: 'top',
  });
  if (!product) return;

  if (product?.isDigital) {
    pushLearnMoreCtaClickDataLayer([
      {
        ...getAnalyticsItemCategoriesByTaxonomy(product?.taxonomy || []),
        item_name: product?.name,
        item_brand: product?.manufacturer,
        item_type: getAnalyticsItemType(product),
        item_id: product?.entityId,
        item_variant: product?.name,
        item_list_id: 'digital_sampling',
        item_list_name: 'digital sampling',
        index: 1,
        quantity: 1,
        price: 0,
      },
    ]);
  } else {
    pushLearnMoreInteraction([
      {
        item_id: product?.entityId,
        item_name: product?.name,
        item_brand: product?.manufacturer,
        item_type: getAnalyticsItemType(product),
        ...getAnalyticsItemCategoriesByTaxonomy(product?.taxonomy),
        index: 1,
        price: 0,
        quantity: 1,
        item_list_id: 'quick_view',
        item_list_name: 'Quick View',
        item_variant: product?.name,
      },
    ]);
  }
  window.splitFactory?.client()?.track('user', 'mb_qv_learn_more', undefined, {
    learnMoreLocation: 'top',
  });

  window.open(product?.url, isLearnMoreNewTab ? '_blank' : '_self');
};
